namespace TabAurous.Production {
    export namespace LossReportService {
        export const baseUrl = 'Production/LossReport';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/LossReport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LossReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
